{
  "name": "pgaoc-client",
  "version": "0.10.1",
  "lint-staged": {
    "*.{js,jsx,ts,tsx}": [
      "eslint --fix",
      "prettier --write"
    ],
    "*.{json,css,md}": [
      "prettier --write"
    ],
    "*.{html}": [
      "eslint --fix"
    ]
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build-internal": "ng build internal-portal --localize",
    "build-member": "ng build member-portal --localize",
    "watch": "ng build --watch --configuration development",
    "lint": "ng lint",
    "i18n-extract": "ng extract-i18n --project=internal-portal --format=xlf --output-path=locale/internal-portal && ng extract-i18n --project=member-portal --format=xlf --output-path=locale/member-portal && npx xliff-simple-merge -i locale/internal-portal/messages.xlf locale/member-portal/messages.xlf -d locale/messages.fr.xlf",
    "prepare": "husky",
    "test": "vitest",
    "test:run": "vitest --run",
    "test:ui": "vitest --ui"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "22.0.1",
    "@angular/cdk": "22.0.1",
    "@angular/common": "22.0.1",
    "@angular/compiler": "22.0.1",
    "@angular/core": "^22.0.1",
    "@angular/forms": "22.0.1",
    "@angular/material": "22.0.1",
    "@angular/platform-browser": "22.0.1",
    "@angular/router": "22.0.1",
    "@floating-ui/dom": "^1.7.4",
    "@maskito/angular": "^5.2.2",
    "@maskito/core": "^5.2.2",
    "@maskito/kit": "^5.2.2",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@popperjs/core": "^2.11.8",
    "@xmldom/xmldom": "^0.9.9",
    "bootstrap": "^5.3.8",
    "buffer": "^6.0.3",
    "eslint-plugin-local-rules": "^3.0.2",
    "eslint-plugin-unused-imports": "^4.1.4",
    "ngx-editor": "^19.0.0-beta.1",
    "ngx-float-ui": "^21.0.1",
    "ngx-image-cropper": "^9.1.6",
    "ngx-toastr": "^20.0.5",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^11.1.0",
    "xliff-simple-merge": "^1.3.0",
    "xml-formatter": "^3.7.0"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.6.1",
    "@angular-eslint/builder": "^22.0.0",
    "@angular/build": "^22.0.1",
    "@angular/cli": "^22.0.1",
    "@angular/compiler-cli": "22.0.1",
    "@angular/localize": "22.0.1",
    "@eslint/js": "^10.0.1",
    "@vitest/ui": "^4.1.4",
    "angular-eslint": "^22.0.0",
    "eslint": "^9.29.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.4",
    "hono": "^4.12.14",
    "husky": "^9.1.7",
    "jsdom": "^29.0.2",
    "lint-staged": "^16.4.0",
    "ng-packagr": "^22.0.0",
    "prettier": "^3.8.3",
    "prettier-eslint": "^16.4.2",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.61.0",
    "vite": "8.0.5",
    "vitest": "^4.1.4"
  }
}
